<router-outlet></router-outlet>

<p-toast position="top-center" key="global" [baseZIndex]="5000">
  <ng-template pTemplate="headless" let-closeFn="closeFn">
    <section class="snackbar flex items-center justify-between w-full px-4 py-3">
      <span class="snackbar-text"> The app has been updated. </span>
      <button (click)="refreshApp()" class="snackbar-action">
        <i class="pi pi-refresh text-white text-lg"></i>
        Refresh
      </button>
    </section>
  </ng-template>
</p-toast>
